import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { _common } from './_common';
import { AppInfo, SessionService } from './session.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-signup-confirmed',
    templateUrl: './signup.confirmed.component.html',
    standalone: true,
    imports: [NgIf, FontAwesomeModule]
})
export class SignupConfirmedComponent implements OnInit {


  _common = _common;
  appName: string;
  app: AppInfo;
  endpoint: string;
  mobile: string;
  isMobile = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,

  ) {
    this.route.queryParams.subscribe((params) => {

      this.appName = params.app;
      this.endpoint = params.endpoint;
      this.mobile = params.mobile;
      this.app = SessionService.APPS.find((c) => c.id == this.appName);

    })
  }

  ngOnInit() {
    this.isMobile = screen.width < 500 || screen.height < 500;
    window.scrollTo(0, 0);
  }



}
